/* eslint-disable no-underscore-dangle */
import Vue from 'vue';
const incr = val => ((+val || 0) + 1) % 0xFFFFFF;
const OB_REV_FIELD_ADD = '$$dictRevisionAdd';
const OB_REV_FIELD_REMOVE = '$$dictRevisionRemove';
export function createObservableDict() {
  const itemRevs = Vue.observable({
    [OB_REV_FIELD_ADD]: 0,
    [OB_REV_FIELD_REMOVE]: 0
  });
  const store = Object.create(null);
  Object.defineProperty(store, '__ob__', {
    value: itemRevs.__ob__
  });
  return new Proxy(store, {
    get(target, key) {
      const itemRev = itemRevs[key];
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      if (typeof itemRev !== 'number') itemRevs[OB_REV_FIELD_ADD]; // 如果key不存在，它可能在未来会突然出现
      // else .... // 不需要关心，在 deleteProperty 的时候会额外触发一下 itemRevs[key] 的
      return Reflect.get(target, key);
    },
    set(target, key, value) {
      if (typeof key === 'string') {
        if (target[key] === value) return true;
        const itemRev = itemRevs[key];
        if (typeof itemRev !== 'number') itemRevs[OB_REV_FIELD_ADD] = incr(itemRevs[OB_REV_FIELD_ADD]);
        Vue.set(itemRevs, key, incr(itemRev));
      }
      return Reflect.set(target, key, value);
    },
    has(target, p) {
      const result = Reflect.has(target, p);
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      if (result) itemRevs[OB_REV_FIELD_REMOVE];
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      else itemRevs[OB_REV_FIELD_ADD];
      return result;
    },
    deleteProperty(target, key) {
      if (typeof key === 'string') {
        const itemRev = itemRevs[key];
        if (typeof itemRev === 'number') {
          itemRevs[OB_REV_FIELD_REMOVE] = incr(itemRevs[OB_REV_FIELD_REMOVE]);
          itemRevs[key] = incr(itemRevs[key]); // 不知道为什么删除key居然没触发响应式，还得额外通知下
          Vue.delete(itemRevs, key);
        }
      }
      return Reflect.deleteProperty(target, key);
    },
    defineProperty( /* target, property, attributes*/
    ) {
      throw new Error('Cannot call defineProperty on ObservableDict');
    },
    ownKeys(target) {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      itemRevs[OB_REV_FIELD_ADD];
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      itemRevs[OB_REV_FIELD_REMOVE];
      return Reflect.ownKeys(target);
    }
  });
}
//# sourceMappingURL=ObservableDict.js.map
